export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.7.25-2030.59",
  commitId: "386b049e5d48b0a6725945f706fc0aa7a56c6f90",
  commitTime: "2026-07-25T20:30:59.000Z",
});
